'use strict';
const angular = require('angular');
const {isFunction, noop} = angular;

//TODO(Angular): update the digest-in-progress check when needed (if angular impl changes)
module.exports = [
  '$provide',
  function ($provide) {
    /**
     * @ngdoc service
     * @name rx.$rootScope
     *
     * @requires $delegate
     *
     * @description
     * `$rootScope` decorator that extends the existing `$rootScope` service
     * with additional methods. These methods are Rx related methods, such as
     * methods to create observables or observable functions.
     */
    $provide.decorator('$rootScope', ['$delegate', decorateService]);

    function decorateService($delegate) {

      Object.defineProperties($delegate.constructor.prototype, {
        /**
         * @ngdoc property
         * @name rx.$rootScope.$toObservable
         *
         * @description
         * Provides a method to create observable methods.
         */
        '$safeApply': {
          /**
           * @ngdoc function
           * @name $rootScope.$safeApply#value
           *
           * @description
           * If a digest cycle is currently in progress, the function is executed immediately. Otherwise the function is
           * called using this scope.apply.
           *
           * @param {function} fn A function to execute.
           */
          value: function (fn) {
            var scope = this;

            fn = isFunction(fn) ? fn : noop;

            (scope.$$phase || (scope.$root && scope.$root.$$phase)) ? fn() : scope.$apply(function () {
              // using a wrapper function because scope.$apply always calls the function with the current scope as the first argument, which is almost always undesirable.
              fn();
            });
          },
          /**
           * @ngdoc property
           * @name rx.$rootScope.$safeApply#enumerable
           *
           * @description
           * Enumerable flag.
           */
          enumerable: false,
          configurable: true,
          writable: true
        },
        /**
         * @ngdoc property
         * @name rx.$rootScope.$toObservable
         *
         * @description
         * Provides a method to create observable methods.
         */
        '$bindSafeApply': {
          /**
           * @ngdoc function
           * @name $rootScope.$safeApply#value
           *
           * @description
           * If a digest cycle is currently in progress, the function is executed immediately. Otherwise the function is
           * called using this scope.apply.
           *
           * @param {function} fn A function to execute.
           */
          value: function (fn) {
            var scope = this;

            fn = isFunction(fn) ? fn : noop;

            return function () {
              var args = arguments;
              (scope.$$phase || scope.$root.$$phase) ? fn.apply(null, args) : scope.$apply(function () {
                fn.apply(null, args);
              });
            }
          },
          /**
           * @ngdoc property
           * @name rx.$rootScope.$safeApply#enumerable
           *
           * @description
           * Enumerable flag.
           */
          enumerable: false,
          configurable: true,
          writable: true
        },
        /**
         * @ngdoc property
         * @name rx.$rootScope.$toObservable
         *
         * @description
         * Provides a method to create observable methods.
         */
        '$safeApplyFunction': {
          /**
           * @ngdoc function
           * @name $rootScope.$safeApply#value
           *
           * @description
           * If a digest cycle is currently in progress, the function is executed immediately. Otherwise the function is
           * called using this scope.apply.
           *
           * @param {function} fn A function to execute.
           */
          value: function (fn) {
            var scope = this;

            return function () {
              var self = this;
              var args = arguments;
              fn = isFunction(fn) ? fn : noop;

              (scope.$$phase || (scope.$root && scope.$root.$$phase)) ?
                fn.apply(self, args) :
                scope.$apply(function () {
                  fn.apply(self, args);
                });
            }
          },
          /**
           * @ngdoc property
           * @name rx.$rootScope.$safeApply#enumerable
           *
           * @description
           * Enumerable flag.
           */
          enumerable: false,
          configurable: true,
          writable: true
        }
      });

      return $delegate;
    }
  }];


// WEBPACK FOOTER //
// ./src/js/core-utilities/safeApply-operator/safeApply.js